import { imageField } from 'molecules/Image/config';

import type { Input } from '@builder.io/sdk';

export const basicSwitchbackFields = [
  {
    name: 'mediaPosition',
    type: 'string',
    enum: ['left', 'right'],
    defaultValue: 'left',
  },
  {
    name: 'imagePosition',
    type: 'string',
    enum: ['top', 'center', 'bottom'],
    defaultValue: 'center',
  },
  {
    name: 'size',
    type: 'string',
    enum: [
      'largeHorizontalRectangle',
      'largeSquare',
      'largeVerticalRectangle',
      'mediumHorizontalRectangle',
      'mediumSquare',
      'mediumVerticalRectangle',
      'smallHorizontalRectangle',
      'smallSquare',
      'smallVerticalRectangle',
    ],
    defaultValue: 'mediumSquare',
  },
  {
    name: 'basicPoints',
    type: 'list',
    subFields: [
      {
        name: 'eyebrowHtmlTag',
        type: 'string',
        enum: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
        defaultValue: 'h3',
        helperText: 'Select the HTML heading tag for the eyebrow',
      },
      {
        name: 'eyebrow',
        type: 'string',
      },
      {
        name: 'body',
        type: 'richText',
      },
      {
        name: 'cta',
        type: 'object',
        subFields: [
          {
            name: 'label',
            type: 'string',
          },
          {
            name: 'link',
            type: 'string',
          },
        ],
      },
      {
        name: 'footnote',
        type: 'string',
      },
    ],
  },
  imageField('image'),
] as const satisfies DeepReadonly<Input[]>;

const basicSwitchbackConfig = {
  name: 'Basic Switchback',
  inputs: basicSwitchbackFields,
};

export type BasicSwitchbackProps = GenerateBuilder<typeof basicSwitchbackFields>;

export default basicSwitchbackConfig;
